import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20358a31"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "sms-modal-label"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  id: "emaillogs-scroller",
  class: "modal-body"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  class: "col-md-4 right-border vertical-scroll",
  style: {"overflow-x":"hidden"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  class: "row",
  style: {"padding":"5px 0 0 0px"}
}
const _hoisted_13 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_14 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_15 = {
  class: "row",
  style: {"padding":"0 0 5px 0px"}
}
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row bottom-border" }, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "col-md-8 vertical-scroll mt-auto mb-auto tenantresponsecontainer text-center",
  style: {"border-left":"1px solid #9b9b9b"}
}
const _hoisted_19 = {
  class: "tenantresponse",
  style: {"margin-top":"100px"}
}
const _hoisted_20 = {
  key: 0,
  class: "tenantresponse"
}
const _hoisted_21 = {
  key: 1,
  class: "col-md-8 vertical-scroll",
  style: {"border-left":"1px solid #9b9b9b"}
}
const _hoisted_22 = {
  key: 0,
  class: "row log-element"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 text-secondary" }, "To", -1))
const _hoisted_24 = { class: "col-md-10" }
const _hoisted_25 = {
  class: "row multiselecttags",
  style: {"padding":"0 0 0 15px"}
}
const _hoisted_26 = {
  key: 1,
  class: "row log-element"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 text-secondary" }, "CC", -1))
const _hoisted_28 = { class: "col-md-10" }
const _hoisted_29 = {
  class: "row multiselecttags",
  style: {"padding":"0 0 0 15px"}
}
const _hoisted_30 = {
  key: 2,
  class: "row log-element"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 text-secondary" }, "BCC", -1))
const _hoisted_32 = { class: "col-md-10" }
const _hoisted_33 = {
  class: "row multiselecttags",
  style: {"padding":"0 0 0 15px"}
}
const _hoisted_34 = {
  key: 3,
  class: "row log-element"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 text-secondary" }, "Subject", -1))
const _hoisted_36 = { class: "col-md-10" }
const _hoisted_37 = {
  key: 4,
  class: "row mt-3"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label text-secondary" }, "Attachments", -1))
const _hoisted_39 = { class: "col-md-10" }
const _hoisted_40 = { class: "list-unstyled" }
const _hoisted_41 = ["href"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip mr-2" }, null, -1))
const _hoisted_43 = {
  key: 5,
  class: "row"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 text-secondary" }, "Message", -1))
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { class: "modal-footer" }

import $ from 'jquery';
import _get from "lodash/get";
import moment from "moment-timezone";
import { computed, ref, inject, onMounted } from 'vue';
import { useStore } from 'vuex';
import { Booking, EmailLogs, EmailLog } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailLogsModal',
  props: {
    name: {},
    title: {},
    target: {},
    chronorder: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = useStore();
const actProperty: any = inject('actProperty');
const previousbooking = ref<Booking | undefined>(undefined);

const booking = computed(() => store.getters['diary/booking']);
const current = computed(() => store.getters['diary/currentlog']);
const emailAttachmentsFlag = computed(() => {
  if (current.value && Array.isArray(current.value.attachments)) {
        return current.value.attachments.some(attachment => 'path' in attachment);
    }
    return false;
});


const getEmailLogs = async (bookingid: string): Promise<EmailLogs> => {
  return store.dispatch('diary/getEmailLogs', bookingid);
};

const getPreviousBooking = async (bookingid: string): Promise<Booking> => {
  return store.dispatch('property/getPreviousBooking', bookingid);
};
const setCurrentEmailLog = (log: EmailLog): void => {
  store.commit('diary/setCurrentEmailLog', log);
};

const init = async () => {
  if (booking.value.id) {
    previousbooking.value = await getPreviousBooking(booking.value.id);
  }
  if(emaillogs.value.length > 0){
    setSelected(emaillogs.value[0]);
  }
};

const setSelected = (value: EmailLog) => {
  setCurrentEmailLog(value);
};


const refresh = () => {
  getEmailLogs(booking.value.id).then(() => {
    var container = ($("#emaillogs-scroller") as any);
    if (container) container.scrollTop = container.scrollHeight;
  });
};

const emaillogs = computed(() => {
  let logs: EmailLog[] = [];
  let previouslogs: EmailLog[] = [];
  if (props.target === "Tenant") {
    logs = booking.value.emaillogs.tenantemaillogs;
    if(props.chronorder === "Issue Report") {
      logs = booking.value.emaillogs.issuereporttenantlogs;
    }
  } else if (props.target === "Landlord") {
    logs = booking.value.emaillogs.landlordemaillogs;
    if(props.chronorder === "Issue Report") {
      logs = booking.value.emaillogs.issuereportlandlordlogs;
    }
  } else if ((props.target === 'Managed Client' || props.target === 'Non-Managed Client') && props.chronorder === 'Issue Report') {
    logs = [...booking.value.emaillogs.issuereportclientlogs];
  } else if ((props.target === 'Managed Client' || props.target === 'Non-Managed Client') && props.chronorder === 'Correspondance/Feedback to Client') {
    logs = [...booking.value.emaillogs.feedbackemaillogs];
    if(previousbooking.value?.id && previousbooking.value?.emaillogs?.feedbackemaillogs?.length > 0) {
      previouslogs = [...previousbooking.value.emaillogs.feedbackemaillogs];
      previouslogs.forEach((l: EmailLog) => l.bookingid = previousbooking.value!.id);
    }
  } else if (props.target === "Client") {
    logs = booking.value.emaillogs.clientemaillogs;
    if(props.chronorder === "Issue Report") {
      logs = booking.value.emaillogs.issuereportclientlogs;
    }
  } else if (props.target === "Data Entry") {
    logs = booking.value.emaillogs.dataentryemaillogs;
  } else if (props.target === "Invoice") {
    logs = booking.value.emaillogs.issuereportinvoicelogs;
  }
  logs = sortLogs(logs);
  if(previouslogs.length) {
    previouslogs = sortLogs(previouslogs);
    logs = [...previouslogs, ...logs];
  }
  return logs;
});

const sortLogs = (logs: EmailLog[]): EmailLog[] => {
  return logs.sort((l1: EmailLog, l2: EmailLog) => {
    if (moment.utc(l1.logdate).isAfter(moment.utc(l2.logdate))) {
      return 1;
    } else if (moment.utc(l1.logdate).isBefore(moment.utc(l2.logdate))) {
      return -1;
    } else {
      return 0;
    }
  });
}

const shortSubject = (value: string) => {
  if (value && value.length > 50) return value.substring(0, 50) + "..";
  else return value;
}

const getButtonLabel = (val: string) => {
  let label = val;
  if(val === 'yes') label = 'Yes';
  else if(val === 'no') label = 'No';
  else if(val === 'callback') label = 'Call Me';
  else if(val === 'option1') label = 'Option 1';
  else if(val === 'option2') label = 'Option 2';
  else if(val === 'option3') label = 'Option 3';
  else if(val === 'option4') label = 'Option 4';
  return label;
}

const show = () => {
  if ($(`#${props.name}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.name + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.name}`).show();
  }
}
const hide = () => {
  if ($(`#${props.name}`).length > 0) {
    $(`#${props.name}` + 'Backdrop').remove();
    $(`#${props.name}`).hide();
  }
};
__expose({init, show, hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.name,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`smsmodal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_7)
        ]),
        (booking.value && booking.value.emaillogs)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emaillogs.value, (log, $logindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["row", {'text-secondary': log.bookingid && log.bookingid != booking.value.id}]),
                      key: $logindex,
                      onClick: ($event: any) => (setSelected(log))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-md-12", {
                    'selected-log': log.logdate == current.value.logdate,
                  }]),
                        style: {"padding":"0 0 0 25px"}
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          (log.subject)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(shortSubject(log.subject)), 1))
                            : _createCommentVNode("", true),
                          (log.tenantresponse)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Tenant responded"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(actProperty).formatUtcDatetimeForDisplay(log.logdate)), 1)
                        ]),
                        _hoisted_17
                      ], 2)
                    ], 10, _hoisted_11))
                  }), 128))
                ]),
                (current.value.tenantresponse)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createTextVNode("Tenant has selected "),
                        _createElementVNode("b", null, _toDisplayString(current.value.responsedescription ?  current.value.responsedescription : getButtonLabel(current.value.tenantresponse)), 1),
                        _createTextVNode(" option from email")
                      ]),
                      (current.value.responseemailaddress)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createTextVNode("The response came from "),
                            _createElementVNode("b", null, _toDisplayString(current.value.responseemailaddress), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (current.value.toaddresses && current.value.toaddresses.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current.value.toaddresses, (selectedemail, $selectedtoindex) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    class: "multiselecttag",
                                    key: $selectedtoindex
                                  }, _toDisplayString(selectedemail), 1))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (current.value.ccaddresses && current.value.ccaddresses.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current.value.ccaddresses, (selectedcc, $selectedccindex) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    class: "multiselecttag",
                                    key: $selectedccindex
                                  }, _toDisplayString(selectedcc), 1))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (current.value.bccaddresses && current.value.bccaddresses.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _hoisted_31,
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current.value.bccaddresses, (selectedbcc, $selectedbccindex) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    class: "multiselecttag",
                                    key: $selectedbccindex
                                  }, _toDisplayString(selectedbcc), 1))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (current.value.subject)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _hoisted_35,
                            _createElementVNode("div", _hoisted_36, _toDisplayString(current.value.subject), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (emailAttachmentsFlag.value && current.value?.attachments?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _hoisted_38,
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("ul", _hoisted_40, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current.value?.attachments, (attachment, index) => {
                                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                                    _createElementVNode("a", {
                                      href: attachment.path,
                                      target: "_blank",
                                      class: "attachment-link"
                                    }, [
                                      _hoisted_42,
                                      _createElementVNode("span", null, _toDisplayString(attachment.filename), 1)
                                    ], 8, _hoisted_41)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (current.value.message)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _hoisted_44,
                            _createElementVNode("div", {
                              class: "col-md-10",
                              innerHTML: current.value.message
                            }, null, 8, _hoisted_45)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-auto",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (refresh()), ["prevent"]))
          }, " Refresh "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Close ")
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})